/**
 * Rialto Film Guide - React Entry Point
 */

import { createRoot } from '@wordpress/element';
import App from './App';

// Find all Rialto app containers and render appropriate components
function initRialtoApp() {
    const containers = document.querySelectorAll('.rialto-app');

    containers.forEach((container) => {
        // Prevent double-init
        if (container.dataset.rialtoInit) return;
        container.dataset.rialtoInit = '1';

        const component = container.dataset.component;
        const props = { ...container.dataset };

        const root = createRoot(container);
        root.render(<App component={component} {...props} />);
    });
}

// Handle both cases: DOM already ready (footer script) or still loading
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRialtoApp);
} else {
    initRialtoApp();
}
